import React from 'react'
import {connect} from 'react-redux'
import styles from './NavigationInfo.scss'
import _ from 'lodash'
import {urls} from 'lib/urls'
import {routeSelectors} from 'data/resources/routes'
import {tripSelectors} from 'data/resources/trips'
import {Distance, Elevation} from 'common/units'
import {j} from 'lib/textUtils'

class _NavigationInfo extends React.PureComponent {
  render () {
    const {troute, navObject} = this.props

    return (
      <div className={styles.NavigationInfo}>
        <h2>{_.capitalize(troute.navType)} Navigated</h2>
        <hr />
        <div className={styles.container}>
          <div>
            <div className={styles.navItemName}>
              <a href={`/${troute.navType}s/${troute.navId}`}>{troute.navName}</a>
            </div>
            {navObject && <div className={styles.navItemMetrics}>
              <span>{j([navObject.locality, navObject.administrativeArea])}</span>
              <span><Distance short bigUnits value={navObject.distance} /></span>
              <span><Elevation short value={navObject.elevationGain} /></span>
            </div>}
          </div>
          <div>
            <img src={urls.staticMap(troute.navType, 'micro', troute.navId)} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  if (!(ownProps.troute.navId && ownProps.troute.navType)) {
    return {}
  }
  const navObject = ownProps.troute.navType === 'trip'
    ? tripSelectors.find(state, ownProps.troute.navId)
    : routeSelectors.find(state, ownProps.troute.navId)
  return {navObject}
}

export const NavigationInfo = connect(
  mapStateToProps
)(_NavigationInfo)
